module.exports = __webpack_public_path__ + "portal-static/img/1首页--1实验用房使用排行_60.9bb0bdb5.jpg";